export default __webpack_public_path__ + "static/media/plain-sticker-X.6c93cb68.png";